import {BlockMath, InlineMath} from "react-katex";

const LinearAlgebraIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <h1 className="tw-header font-bold text-gray-900 mb-4">Linear Algebra</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Linear algebra is the branch of mathematics that deals with <strong>vectors</strong>,
                <strong>matrices</strong>, and <strong>linear transformations</strong>. It provides
                the mathematical foundation for understanding multidimensional spaces and is essential
                for machine learning, computer graphics, data science, and engineering. At its core,
                linear algebra studies systems of linear equations, which can be represented as
                <span className="ml-1"><InlineMath math="A\vec{x} = \vec{b}"/></span>, where <InlineMath math="A"/> is a matrix,
                <span className="ml-1"><InlineMath math="\vec{x}"/></span> is the unknown vector, and <span className="ml-1 mr-1"><InlineMath math="\vec{b}"/></span>
                is the result vector.
            </p>
            <hr className="mt-2 mb-2"/>
            <p className="tw-subtitle text-gray-600">
                Matrix operations form the backbone of linear algebra. Matrix multiplication, for example,
                combines two matrices <InlineMath math="A"/> and <InlineMath math="B"/> to produce a new
                matrix <InlineMath math="C"/>:
            </p>
            <BlockMath math="C_{ij} = \sum_{k=1}^{n} A_{ik} B_{kj}"/>
            <p className="tw-subtitle text-gray-600">
                Key concepts include <strong>eigenvalues</strong> and <strong>eigenvectors</strong>,
                which satisfy the equation <InlineMath math="A\vec{v} = \lambda\vec{v}"/>, where
                <span className="ml-1"><InlineMath math="\lambda"/></span> is the eigenvalue. The <strong>determinant</strong> of
                a matrix tells us about its invertibility and geometric properties, while concepts
                like <strong>rank</strong>, <strong>null space</strong>, and <strong>column space</strong>
                help us understand the structure and behavior of linear transformations in
                high-dimensional spaces.
            </p>
        </div>
    )
}

export default LinearAlgebraIntro;